import {
  Heading as _Heading,
  Tag as _Tag,
  Button as _Button,
  FONT_SIZE,
  mq,
  COLOR,
  RatingStar as _RatingStar,
  FONT_WEIGHT,
} from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const ArtRootWrapper = styled.article`
  font-size: ${FONT_SIZE.S}px;
  margin: 32px 0;

  ${mq.sp} {
    display: grid;
    margin: 16px 0;

    &:not(:last-of-type) {
      padding-bottom: 16px;
      border-bottom: 1px solid ${COLOR.GRAY200.code};
    }
  }
`;

export const DivHeader = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const ReviewInfoRatingStar = styled(_RatingStar)`
  min-width: 80px;
  margin-bottom: 8px;
  margin-right: 8px;

  ${mq.sp} {
    margin-right: 0;
    margin-bottom: 4px;
  }

  /* MEMO: RatingStar の高さが line-height によって変わるため */
  font-size: 0;
  & > button {
    font-size: 0;
  }
`;

/** ネタバレタグ */
export const SpoilerTag = styled(_Tag)`
  margin-bottom: 8px;
  margin-right: 8px;

  ${mq.sp} {
    margin-left: 8px;
    margin-bottom: 4px;
    margin-right: 0;
  }
`;

export const Heading = styled(_Heading)`
  font-weight: ${FONT_WEIGHT.BOLD};
  word-break: break-all;
  margin-bottom: 8px;

  ${mq.sp} {
    margin-bottom: 4px;
  }
`;

export const DivReviewerBlock = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 8px;
  color: ${COLOR.GRAY500.code};

  ${mq.sp} {
    margin-top: 4px;
  }
`;

export const AnchorLinkWrapper = styled.div`
  margin-top: 8px;
  ${mq.sp} {
    width: 100%;
    margin-top: 4px;
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const AnchorLink = styled.a`
  color: ${COLOR.BLUE900.code};
  margin-right: 8px;
  word-break: break-all;

  @media (any-hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const TimePost = styled.time`
  margin-top: 8px;
  margin-right: 8px;
  color: ${COLOR.GRAY500.code};
  font-size: ${FONT_SIZE.S}px;

  ${mq.sp} {
    margin-top: 4px;
    margin-right: 4px;
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const TagPurchased = styled(_Tag)`
  margin-top: 8px;

  ${mq.sp} {
    margin-top: 4px;
  }
`;

export const DivEvaluationBlock = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  ${mq.sp} {
    margin-top: 8px;
    flex-direction: column;
    align-items: start;
  }
`;

export const DivPostEvaluation = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const ButtonYes = styled(_Button)`
  width: 56px;
  height: 32px;
  font-size: ${FONT_SIZE.XS}px;

  ${mq.sp} {
    width: 52px;
    height: 24px;
    font-size: ${FONT_SIZE.XXS}px;
  }
`;

export const ParVoteText = styled.p`
  font-size: ${FONT_SIZE.S}px;

  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const ParText = styled.p`
  margin-right: 8px;
  font-size: ${FONT_SIZE.S}px;

  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const ParThankText = styled.p`
  ${mq.sp} {
    margin-top: 4px;
    font-size: ${FONT_SIZE.XS}px;
  }
`;
